var render = function render(){var _vm=this,_c=_vm._self._c;return _c('scroll-page',{attrs:{"titleArrs":_vm.titleArrs,"pageArrs":_vm.pageArrs}})
}
var staticRenderFns = []

export { render, staticRenderFns }